import React from "react";
import cl from "classnames";
import { Field, connect } from "formik";
import classes from "../../styles/initialEventDetails.module.scss";

const FlexibleSwitch = connect(({ formik }) => (
  <div style={{ visibility: formik.values.start_date ? "visible" : "hidden" }}>
    <Field
      type="checkbox"
      className={cl("ux-checkbox", classes.FlexibleInput)}
      value={formik.values.isFlexible}
      name="isFlexible"
      id="chk-flexible"
      data-ga="flexible"
    />
    <label htmlFor="chk-flexible" data-test-id="venueSearch-flexibleDates">
      I'm flexible on dates and times
    </label>
  </div>
));

export default FlexibleSwitch;
